import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { useSelector } from "react-redux";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcElectronics } from "react-icons/fc";
import {
  CompanyAssetsInfo,
  CompanyAssetsSchema,
} from "../../../Schemas/employee/company_assets_schema";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomTextArea from "../../../CustomComponent/custom_textarea";

const AddCompanyAssets = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [leadOwner, setLeadOwner] = useState();

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, []);
  const handelSubmit = (values) => {
    values = { ...values, status: values?.assignTo ? "pending" : "available" };
    let formdata = new FormData();
    for (let key in values) {
      formdata.append(key, values[key]);
    }
    setLoading(true);
    performRequest("POST", "/companyassets/createassets/", formdata, {
      contentType: "multipart/form-data",
    })
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Assets info added successfully!");
          navigate(`/company-assets/${res?.data?.id}`);
        } else {
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcElectronics></FcElectronics> Add Assets
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Add Assets</h2>
            </div>
            <Formik
              initialValues={CompanyAssetsInfo}
              validationSchema={CompanyAssetsSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="name" type="text" />
                        {props.touched.name && props.errors.name && (
                          <p className="text-danger">{props.errors.name}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Asset id
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="assetId" type="text" />
                        {props.touched.assetId && props.errors.assetId && (
                          <p className="text-danger">{props.errors.assetId}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="photo"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue("photo", e.target.files[0])
                          }
                        />
                        {props.touched.photo && props.errors.photo && (
                          <p className="text-danger">{props.errors.photo}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Price
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="price" type="text" />
                        {props.touched.price && props.errors.price && (
                          <p className="text-danger">{props.errors.price}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Assign to</label>
                      <div className="w-100 col">
                        <CustomSelect name="assignTo" type="text">
                          <option value="">Select assign to</option>
                          {leadOwner &&
                            leadOwner.map((state, index) => (
                              <option key={index} value={state?.id}>
                                {state?.userName}
                              </option>
                            ))}
                        </CustomSelect>
                        {props.touched.assignTo && props.errors.assignTo && (
                          <p className="text-danger">{props.errors.assignTo}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Assign date
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="assignDate" type="date" />
                        {props.touched.assignDate &&
                          props.errors.assignDate && (
                            <p className="text-danger">
                              {props.errors.assignDate}
                            </p>
                          )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Status
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="status" type="text">
                          <option value="">Select</option>
                          <option value="available">Available</option>
                          <option value="pending">Pending Approval</option>
                          <option value="assigned">Assigned</option>
                          <option value="in_use">In Use</option>
                          <option value="under_maintenance">
                            Under Maintenance
                          </option>
                          <option value="returned">Returned</option>
                          <option value="lost">Lost</option>
                          <option value="damaged">Damaged</option>
                          <option value="retired">Retired / Scrapped</option>
                        </CustomSelect>
                        {props.touched.status && props.errors.status && (
                          <p className="text-danger">{props.errors.status}</p>
                        )}
                      </div>
                    </div> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          name="description"
                          rows={4}
                          type="text"
                        />
                        {props.touched.description &&
                          props.errors.description && (
                            <p className="text-danger">
                              {props.errors.description}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create Asset" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AddCompanyAssets;
